import { apiGet } from './api-service';

const path = 'communication';

export interface CommunicationHistoryQueryParams {
    dateFrom: string;
    dateTo: string;
    limit: number;
    page: number;
    clientId?: string;
    employeeId?: string;
    type?: string;
    template?: string;
    to?: string;
    success?: boolean;
}

export const COMMUNICATION_TYPE = {
    SMS: 1,
    EMAIL: 2,
    WHATSAPP: 3
} as const;

export const COMMUNICATION_TEMPLATE = {
    COGNITO_AUTH: 1,
    TASK_DOCUMENT_EXPIRES_IN_DAYS: 2,
    TASK_DOCUMENT_EXPIRED: 3,
    TASK_DOCUMENT_EXPIRED_DAYS_AGO: 4,
} as const;

export async function getHistoryById(id: string) {
    return await apiGet('core', `${path}/history/${id}`);
}

export async function getHistory(params: CommunicationHistoryQueryParams) {
    const queryParams: Record<string, string> = {
        dateFrom: params.dateFrom,
        dateTo: params.dateTo,
        limit: params.limit.toString(),
        page: params.page.toString()
    };

    if (params.clientId) queryParams.clientId = params.clientId;
    if (params.employeeId) queryParams.employeeId = params.employeeId;
    if (params.type) queryParams.type = params.type;
    if (params.template) queryParams.template = params.template;
    if (params.to) queryParams.to = params.to;
    if (params.success !== undefined) queryParams.success = params.success.toString();

    const response = await apiGet('core', `${path}/history`, { queryParams });
    return response;
}
